import { makeAutoObservable } from 'mobx';

class AppStore {
  isLoading = false;
  currentTime = new Date();

  constructor() {
    makeAutoObservable(this);
  }

  setLoading(value: boolean): void {
    this.isLoading = value;
  }

  updateTime(): void {
    this.currentTime = new Date();
  }

  get formattedTime(): string {
    const h = this.currentTime.getHours();
    const m = this.currentTime.getMinutes();
    const s = this.currentTime.getSeconds();

    const pad = (n: number): string => (n < 10 ? `0${n}` : String(n));

    return `${pad(h)}:${pad(m)}:${pad(s)}`;
  }
}

export default AppStore;
